export default {
  namespaced: true,
  state: {
    solutionId: null,
  },
  mutations: {
    SET_SOLUTION_ID(state, payload) {
      state.solutionId = payload;
    },
  },
  getters: {
    getSolutionId(state) {
      return state.solutionId;
    },
  },
  actions: {
    setSolutionId({commit}, payload) {
      commit('SET_SOLUTION_ID', payload);
    }
  }
}